
export default {
  name: 'AppImageStack',
  props: {
    imageUrl1: { type: String, required: true },
    imageUrl2: { type: String, required: true }
  }
};
